import { render, staticRenderFns } from "./addPlural.vue?vue&type=template&id=cf40bd9c&scoped=true"
import script from "./addPlural.vue?vue&type=script&lang=js"
export * from "./addPlural.vue?vue&type=script&lang=js"
import style0 from "./addPlural.vue?vue&type=style&index=0&id=cf40bd9c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf40bd9c",
  null
  
)

export default component.exports